/**
 * F17 step 1 — Tipologie controsoffitti.
 *
 * Lettura: catalogo di sistema (is_system=true) + custom per org.
 * Solo lettura per ora — la creazione tipologie custom è step successivo.
 */
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useCurrentOrganization } from '@/contexts/OrganizationContext';

export interface CeilingTypology {
  id: string;
  code: string;
  name: string;
  description: string | null;
  structure_type: 'single' | 'double';
  attachment_type: 'fixed' | 'suspended';
  hanger_spacing_mm: number | null;
  primary_profile_spacing_mm: number | null;
  secondary_profile_spacing_mm: number | null;
  reference_system: string | null;
  notes: string | null;
  is_system: boolean;
  organization_id: string | null;
}

export const useCeilingTypologies = () => {
  const { currentOrganizationId } = useCurrentOrganization();

  return useQuery({
    queryKey: ['ceiling-typologies', currentOrganizationId],
    queryFn: async (): Promise<CeilingTypology[]> => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const { data, error } = await (supabase as any)
        .from('ceiling_typologies')
        .select('*')
        .order('is_system', { ascending: false })
        .order('code');
      if (error) throw error;
      return (data ?? []) as CeilingTypology[];
    },
    staleTime: 60_000,
  });
};
